import { httpGet } from "@/api/connection";
import { Location } from "./locations.types";

export type GetLocationsQuery = {
  include_groups?: boolean;
  include_meta_locations?: boolean;
  office_id?: number;
  group_id?: number;
  location_id?: number;
  search?: string;
};

export type GetLocationsResponse = Location[];

export type GetLocationsFn = (
  query?: GetLocationsQuery
) => Promise<GetLocationsResponse>;

const destroyedLocation: Location = {
  location_id: -1,
  location_name: "Destroyed",
  location_type: "Destroyed",
  location_group: null,
  is_parent: 0,
  parent_id: null,
  office_id: 0,
  office_name: "",
  user_id: null,
  user_name: null,
  evidence_count: 0,
  storage_count: 0,
};

const releasedLocation: Location = {
  location_id: 1,
  location_name: "Released",
  location_type: "Released",
  location_group: null,
  is_parent: 0,
  parent_id: null,
  office_id: 0,
  office_name: "",
  user_id: null,
  user_name: null,
  evidence_count: 0,
  storage_count: 0,
};

const atParentLocation: Location = {
  location_id: 0,
  location_name: "At Parent",
  location_type: "At Parent",
  location_group: null,
  is_parent: 0,
  parent_id: null,
  office_id: 0,
  office_name: "",
  user_id: null,
  user_name: null,
  evidence_count: 0,
  storage_count: 0,
};

const metaLocations: Location[] = [
  destroyedLocation,
  releasedLocation,
  atParentLocation,
];

const getLocations: GetLocationsFn = async (query) => {
  const result = await httpGet(`/locations`, query);
  if (query?.include_meta_locations) {
    return [...result, ...metaLocations];
  }
  return result;
};

export const LocationsAPI = {
  get: getLocations,
  metaLocations: {
    destroyed: destroyedLocation,
    released: releasedLocation,
    atParent: atParentLocation,
  },
};
